import { Pipe, PipeTransform } from '@angular/core';
import { UrlSasDTO } from '../models/AzureStorage/UrlSasDTO';

@Pipe({
  name: 'filterArray'
})
export class FilterOptionsFromArray implements PipeTransform {
  constructor() {}

  transform(items: string[], searchText: string): string[] {
    if (searchText == null || searchText === '' || items == null) {
      return items;
    }
    var result = items.filter(item => item.toLowerCase().includes(searchText.toLowerCase()) );
    
    return result;
  }
}